import { PropsWithChildren } from 'react';

import { twMerge } from '@/core/tamagoshiTailwind/util/twMerge';

type Props = PropsWithChildren & {
  className?: string;
};

// 1376px is the max width of the content that corresponds to 1440px - 2x 32px padding
export const SectionBlock = ({ children, className }: Props) => (
  <div
    className={twMerge(
      'relative w-full max-w-[1376px] px-m empty:hidden desktop:px-0',
      className,
    )}
  >
    {children}
  </div>
);
